<template>
    <div>
        <Row type="none" class="bg-white rounded shadow min-h-screen">

            <RowColumn sm-size="3" md-size="3" xl-size="2">
                <div class="container">
                    <ButtonTag variant="primary" url="product-categories/add" class="mt-sm-3 ml-md-1.5" v-if="canManageProducts()"> {{ $t('add') }}</ButtonTag>
                </div>
            </RowColumn>
            <Row class="mx-3.5">
                <TableTag class="w-full"
                    getter-name="getProductCategories"
                    :headers="['id', 'name', 'actions']"
                    :body-properties="['id', 'name', 'actions']"
                >
                    <template v-slot:actions="row">
                        <img src="/images/edit.png" alt="" class="h-6 cursor-pointer" @click="$i18nHelper.toUrl('product-categories/' + row.item.id)">
                        <img src="/images/Union.png" alt="" class="h-6 pl-3 cursor-pointer" @click="$bvModal.show('delete-category-' + row.item.id)">

                        <Modal
                            text="deleteConfirm"
                            ok-text="yes"
                            cancel-text="no"
                            :is-ok-only="false"
                            :context="{name: row.item.name}"
                            :id="'delete-category-' + row.item.id"
                            :on-ok-pressed="() => {modalOk(row.item.id)}"
                        />
                    </template>
                </TableTag>
            </Row>

            <PaginationRow
                class="mt-4 mx-0.5"
                :search="{page: 1}"
                base-url="product-categories"
                method-name="fetchProductCategories"
                :total-items="getProductCategoriesTotalCount"
            />

        </Row>
        <Row>
            <RowColumn type="none" class="mt-3">
                <TreeCheckBox
                    class="rounded"
                    model-name="categories"
                    placeholder="treeView"
                    :model-form="treeModelForm"
                    :options="this.getProductCategoriesTree"
                    :multiple="false"
                    :is-always-open="true"
                />
            </RowColumn>
        </Row>
    </div>
</template>

<script>
import currencyFormat from "../../mixin/currencyFormatMixin";
import Row from "../../components/html/Row";
import RowColumn from "../../components/RowColumn";
import ButtonTag from "../../components/html/ButtonTag";
import TableTag from "../../components/html/TableTag";
import PaginationRow from "../../components/PaginationRow";
import {mapActions, mapGetters} from "vuex";
import accessMixin from "@/mixin/accessMixin";
import Modal from "@/components/html/Modal";
import TreeCheckBox from "@/components/TreeCheckBox";

export default {
    name: "ProductsList",
    components: {
        TreeCheckBox,
        Modal,
        PaginationRow,
        TableTag,
        ButtonTag,
        RowColumn,
        Row,
    },
    mixins: [currencyFormat, accessMixin],
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'category'},
            ],
            treeModelForm: {
                categories: null
            }
        }
    },
    computed: mapGetters(['getProductCategoriesTotalCount', 'getProductCategoriesTree']),
    methods: {
        ...mapActions(['deleteProductCategory', 'fetchProductCategoriesTree', 'setBreadcrumbItems']),
        modalOk(id) {
            this.deleteProductCategory(id)
            .then(() => {
                this.$i18nHelper.toUrl('product-categories/?' + id)
            })
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.fetchProductCategoriesTree()
    },
}
</script>

<style scoped>

</style>